import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useClientHistory, { JOIN, RESULT } from 'client/hooks/useClientHistory';
import useGameActionEnableInfo from 'client/hooks/useGameActionEnableInfo';
import useIsInitSuccessInfo from 'client/hooks/useIsInitSuccessInfo';
import { isAutoTriggerAnimationGames } from 'config/promoGameTypes';
import { updateWinnerAnimationFlag } from 'api/client';
import useClientErrorHandler from './useClientErrorHandler';
import { setShouldUpdateUserWinnerList } from 'client/redux/modules/flags';

function useUserGamePhaseRedirectOnInit() {
    const history = useClientHistory();
    const successInited = useIsInitSuccessInfo();
    const dispatch = useDispatch();
    const { shouldAutoRedirectGameStage } = useGameActionEnableInfo();
    const { isPurePrizeGame } = useSelector(s => s.promoState);
    const { type: gameType, uuid: promoUuid } = useSelector(s => s.promo);
    const { isLogin } = useSelector(s => s.userLoginState);
    const {
        hasGameResult,
        hasFilledSignupForm,
        hasParticipantPrize,
        hasInstantPrize
    } = useSelector(s => s.userEntryState);
    const { unOpenWinnerPrize = [] } = useSelector(s => s.userWinnerPrize);
    const hasUnOpenWinnerPrize = unOpenWinnerPrize.length > 0;
    const errHandler = useClientErrorHandler();

    useEffect(() => {
        const init = async () => {
            if (successInited) {
                if (isLogin && shouldAutoRedirectGameStage) {
                    if (isAutoTriggerAnimationGames(gameType) && hasUnOpenWinnerPrize) {
                        try {
                            await Promise.all(
                                unOpenWinnerPrize.map(({ entryUuid, prize: { uuid: prizeUuid } }) =>
                                    updateWinnerAnimationFlag(promoUuid, entryUuid, prizeUuid)
                                )
                            );
                            dispatch(setShouldUpdateUserWinnerList());
                        } catch (error) {
                            errHandler({ err: error });
                        }
                    }

                    if (isPurePrizeGame) {
                        // 只要其中一個條件不滿足都會去 join 頁
                        //     true: 目前沒有任何一個尚未完成的得獎紀錄，但有沒有看過動畫並不一定要在 result 頁來看
                        //     false: 目前有尚未跑完流程的紀錄
                        if (
                            hasGameResult &&
                            hasFilledSignupForm &&
                            hasParticipantPrize &&
                            hasInstantPrize
                        ) {
                            history.replace(RESULT);
                        } else {
                            history.replace(JOIN);
                        }
                    } else {
                        if (!hasGameResult) {
                            history.replace(JOIN);
                        } else {
                            history.replace(RESULT);
                        }
                    }
                } else {
                    history.replace(JOIN);
                }
            }
        };

        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [successInited]);
}

export default useUserGamePhaseRedirectOnInit;
